import { DictationOrigin } from '@highlight/common'
import IpcRouter from '@shared/ipc/IpcRouter'

export interface getMicActivityQuery {
  lastNumMs: number
  source?: number
}

export interface AsrIpcRouterType {
  getASRInputDevices: () => Promise<any>
  saveConversation: () => Promise<void>
  startDictation: (callOrigin: DictationOrigin) => Promise<void>
  stopDictation: (options: { source: number; callOrigin: DictationOrigin; cancelled?: boolean }) => Promise<void>
}

class AsrIpcRouter extends IpcRouter<AsrIpcRouterType> {
  constructor() {
    super('asr', {
      getASRInputDevices: true,
      saveConversation: true,
      startDictation: true,
      stopDictation: true,
    })
  }
}

export default AsrIpcRouter
